import { getActiveDocument, useAppStore } from '../../state/store';
import { AdjustmentDialog } from './AdjustmentDialog';
import { CanvasSizeDialog } from './CanvasSizeDialog';
import { ColorRangeDialog } from './ColorRangeDialog';
import { ExportDialog } from './ExportDialog';
import { FillDialog } from './FillDialog';
import { FilterDialog } from './FilterDialog';
import { GradientEditor } from './GradientEditor';
import { LanguageDialog } from './LanguageDialog';
import { LayerStyleDialog } from './LayerStyleDialog';
import { LiquifyDialog } from './LiquifyDialog';
import { ImageSizeDialog } from './ImageSizeDialog';
import { ModifySelectionDialog } from './ModifySelectionDialog';
import { NewDocumentDialog } from './NewDocumentDialog';
import { OffsetDialog } from './OffsetDialog';
import { RefineEdgeDialog } from './RefineEdgeDialog';
import { ShortcutsDialog } from './ShortcutsDialog';
import { StrokeDialog } from './StrokeDialog';
import { TutorialDialog } from './TutorialDialog';
import { VectorizeDialog } from './VectorizeDialog';
import { GridSettingsDialog, NewGuideDialog, RotateViewDialog } from './ViewDialogs';

export function Dialogs() {
  const dialog = useAppStore((state) => state.dialog);
  const closeDialog = useAppStore((state) => state.closeDialog);
  const doc = useAppStore(getActiveDocument);
  const gradient = useAppStore((state) => state.gradient);
  const patchGradient = useAppStore((state) => state.patchGradient);

  if (!dialog) return null;

  switch (dialog.kind) {
    case 'newDocument':
      return <NewDocumentDialog open onClose={closeDialog} />;
    case 'shortcuts':
      return <ShortcutsDialog open onClose={closeDialog} />;
    case 'tutorial':
      return <TutorialDialog key="tutorial" open onClose={closeDialog} />;
    case 'language':
      return <LanguageDialog open onClose={closeDialog} />;
    case 'imageSize':
      return doc ? <ImageSizeDialog doc={doc} open onClose={closeDialog} /> : null;
    case 'canvasSize':
      return doc ? <CanvasSizeDialog doc={doc} open onClose={closeDialog} /> : null;
    case 'export':
      return doc ? <ExportDialog doc={doc} open onClose={closeDialog} /> : null;
    case 'fill':
      return doc ? <FillDialog open onClose={closeDialog} /> : null;
    case 'stroke':
      return doc ? <StrokeDialog open onClose={closeDialog} /> : null;
    case 'gradient':
      return (
        <GradientEditor
          gradient={gradient.value}
          presets={gradient.presets}
          onChange={(value) => patchGradient({ value })}
          onClose={closeDialog}
        />
      );
    case 'colorRange':
      return doc ? <ColorRangeDialog open onClose={closeDialog} /> : null;
    case 'refineEdge':
      return doc ? <RefineEdgeDialog open onClose={closeDialog} /> : null;
    case 'vectorize':
      return doc ? <VectorizeDialog open onClose={closeDialog} /> : null;
    case 'rotateView':
      return doc ? <RotateViewDialog open onClose={closeDialog} /> : null;
    case 'newGuide':
      return doc ? <NewGuideDialog open onClose={closeDialog} /> : null;
    case 'gridSettings':
      return <GridSettingsDialog open onClose={closeDialog} />;
    case 'offset':
      return doc ? <OffsetDialog doc={doc} open onClose={closeDialog} /> : null;
    case 'filter':
      return doc ? (
        <FilterDialog key={dialog.filter} id={dialog.filter} doc={doc} open onClose={closeDialog} />
      ) : null;
    case 'liquify':
      return doc ? <LiquifyDialog doc={doc} open onClose={closeDialog} /> : null;
    case 'layerStyle':
      return doc ? (
        <LayerStyleDialog key={doc.activeLayerId} doc={doc} open onClose={closeDialog} />
      ) : null;
    case 'selectionModify':
      return doc ? (
        <ModifySelectionDialog key={dialog.modify} kind={dialog.modify} open onClose={closeDialog} />
      ) : null;
    case 'adjustment':
      // Keyed so switching adjustments remounts with fresh default values.
      return doc ? (
        <AdjustmentDialog
          key={dialog.adjustment}
          id={dialog.adjustment}
          doc={doc}
          open
          onClose={closeDialog}
        />
      ) : null;
    default:
      return null;
  }
}
